import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import SpinnerWithLoadMask from "components/SpinnerWithLoadMask";
import HomeSummaryContent from "layout/homeSummary/HomeSummaryContent";
import ErrorFallbackModal from "components/Modal/ErrorFallbackModal";

const HomeSummary = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallbackModal}>
      <SpinnerWithLoadMask opacity={0.7} fullScreen />
      <HomeSummaryContent />
    </ErrorBoundary>
  );
};

export default HomeSummary;
